import { GlDisclosureDropdown, GlDisclosureDropdownItem, GlFormCheckbox, GlDropdownDivider, GlToggle, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { InternalEvents } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import { getParameterByName, setUrlParams, visitUrl } from '~/lib/utils/url_utility';
import { parseBoolean } from '~/lib/utils/common_utils';
import { s__ } from '~/locale';
import { helpPagePath } from '~/helpers/help_page_helper';
import AccessorUtilities from '~/lib/utils/accessor';
const SHOW_AGE_INDICATOR_KEY = 'blame_show_age_indicator';
const i18n = {
    blamePreferences: s__('Blame|Blame preferences'),
    showAgeIndicator: s__('Blame|Show age indicator legend'),
    ignoreSpecificRevs: s__('Blame|Ignore specific revisions'),
    learnToIgnore: s__('Blame|Learn to ignore specific revisions')
};
export default {
    name: 'BlamePreferences',
    i18n,
    docsLink: helpPagePath('user/project/repository/files/git_blame.md', {
        anchor: 'ignore-specific-revisions'
    }),
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlFormCheckbox,
        GlDropdownDivider,
        GlToggle
    },
    mixins: [
        InternalEvents.mixin()
    ],
    props: {
        hasRevsFile: {
            type: Boolean,
            required: true
        },
        showAgeIndicatorToggle: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    emits: [
        'toggle-age-indicator'
    ],
    data () {
        return {
            isIgnoring: parseBoolean(getParameterByName('ignore_revs')),
            isLoading: false,
            showAgeIndicator: false
        };
    },
    created () {
        this.showAgeIndicator = this.loadShowAgeIndicator();
    },
    mounted () {
        this.$emit('toggle-age-indicator', this.showAgeIndicator);
    },
    methods: {
        loadShowAgeIndicator () {
            if (!AccessorUtilities.canUseLocalStorage()) return false;
            return localStorage.getItem(SHOW_AGE_INDICATOR_KEY) === 'true';
        },
        toggleAgeIndicator () {
            this.showAgeIndicator = !this.showAgeIndicator;
            if (AccessorUtilities.canUseLocalStorage()) {
                localStorage.setItem(SHOW_AGE_INDICATOR_KEY, String(this.showAgeIndicator));
            }
            this.trackEvent('toggle_inline_blame_age_indicator_on_blob_page', {
                property: this.showAgeIndicator ? 'show' : 'hide'
            });
            this.$emit('toggle-age-indicator', this.showAgeIndicator);
        },
        toggleIgnoreRevs () {
            this.isIgnoring = !this.isIgnoring;
            this.isLoading = true;
            visitUrl(setUrlParams({
                ignore_revs: this.isIgnoring
            }));
        },
        visitDocs () {
            visitUrl(this.$options.docsLink);
        }
    }
};
